export default __webpack_public_path__ + "b9d8407b8d15f1397be046fc56322aba.jpg";